import { render, staticRenderFns } from "./PaymentCharge.vue?vue&type=template&id=c4d19800&scoped=true&"
import script from "./PaymentCharge.vue?vue&type=script&lang=js&"
export * from "./PaymentCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d19800",
  null
  
)

export default component.exports